export const EVENT_BREADCRUMB = 'breadcrumbchange'
export const EVENT_CLEAR_FILTERS = 'clearfiltersidebar'
